var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRightChevron = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a_right {\n                fill: none !important;\n            }\n\n            .b_right {\n                fill: #fff;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a_right",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b_right",
    d: "M1.265,0,5.383,4.118,9.5,0l1.265,1.274L5.383,6.657,0,1.274Z",
    transform: "translate(2.672 11.383) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a_right",
    width: 12,
    height: 12
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRightChevron);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_right_chevron.b9f9241b76d2904f005e1c0690d31c72.svg";